import strings from '../../../common/strings';

export const forgotPasswordValidations = {
  email: {
    presence: { allowEmpty: false },
    email: { message: strings.INVALID_EMAIL_MESSAGE },
  },
};
